import { isE2eTestMode } from './appConfig';

export type ClientRoute = ValueOf<typeof routes>;

/**
 * Routes that can be rendered before the user has registered
 * and completed the initial sync
 */
export const preInitialSyncRoutes = {
  login: '/login',
  authRegistration: '/auth-registration',
  authFailed: '/auth-failed',
  notFound: '/404',
  error: '/error',
} as const;

export const roleAgnosticRoutes = {
  home: '/',
  ...preInitialSyncRoutes,
} as const;

export const neighbourhoodRoutes = {
  property: '/properties/:propertyId',
  person: '/properties/:propertyId/people/:personId',
  personEdit: '/properties/:propertyId/people/:personId/edit',
  householdMemberCreate: '/properties/:propertyId/new-household-member',
  contactDetailsEdit: '/properties/:propertyId/people/:personId/edit-contact-details',
  visit: '/properties/:propertyId/visits/:visitId',
  visitCreate: '/properties/:propertyId/log-visit',
  visitEdit: '/properties/:propertyId/visits/:visitId/edit',
  case: '/properties/:propertyId/cases/:caseId',
  caseCreate: '/properties/:propertyId/new-case',
  serviceRequest: '/properties/:propertyId/service-requests/:serviceRequestId',
  note: '/properties/:propertyId/notes/:noteId',
  noteCreate: '/properties/:propertyId/new-note',
  housingApplication: '/properties/:propertyId/applications/:applicationId',
  arrearsArrangement: '/properties/:propertyId/arrangements/:arrangementId',
} as const;

export const neighbourhoodManagerRoutes = {
  activityReport: '/activity-report',
} as const;

export const pcfraRoutes = {
  residentsReport: '/residents-report',
  pcfraProperty: '/pcfra/properties/:propertyId',
  pcfraCreate: '/pcfra/properties/:propertyId/people/:personId/create-pcfra',
  pcfraEdit: '/pcfra/properties/:propertyId/people/:personId/edit-pcfra/:draftId',
} as const;

export const managementRoutes = {
  managementTools: '/management-tools',
} as const;

export const routes = {
  ...roleAgnosticRoutes,
  ...neighbourhoodRoutes,
  ...neighbourhoodManagerRoutes,
  ...pcfraRoutes,
  ...managementRoutes,
} as const;

export const apiRoutes = {
  login: (redirectUri = '', username = '') => {
    const params = new URLSearchParams({ redirectUri, username }).toString();
    return isE2eTestMode ? `/auth/login-e2e-test?${params}` : `/auth/login?${params}`;
  },
  logout: '/auth/logout',
  getDocument: (url: string, mimeType = '') =>
    `/api/documents?${new URLSearchParams({ url, mimeType }).toString()}`,
  uploadRpeep: (personId: number) => `/api/pcfra/upload-rpeep?personId=${personId}`,
  keyOutcomesReport: (from = '', to = '') =>
    `/api/activity-report/key-outcomes-report?${new URLSearchParams({ from, to }).toString()}`,
};
